import React from 'react';
import { omit, isFunction, } from 'lodash';
import { collection, doc, getDoc, query, where, orderBy, limit, addDoc, updateDoc, setDoc, } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { Button, } from 'reactstrap';
import { useToggle, } from 'react-use';
import classnames from 'classnames';

export default function AddButton ({ initialValues, validateOnSubmit = _ => true, itemRef, FormModal, formProps, processValues = _ => _, label = '追加', iconClassName = 'fas fa-fw fa-plus', onFinish, opensInitially = false, ...extraProps }) {
  const [showsModal, toggleModal] = useToggle(opensInitially);
  const onSubmit = async (values) => {
    const ref = isFunction(itemRef) ? itemRef(values) : itemRef;
    const { id } = ref;
    if(!(await validateOnSubmit({ id, ...values }))) return;

    try {
      await setDoc(ref, { ...omit(await processValues({ id, ...values }), ['id', 'ref']), createdAt: new Date(), });
      onFinish && await onFinish({ id, ...values });
      toast.success('追加しました');
      toggleModal(false);
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
  };

  return (
    <Button color="primary" outline onClick={_ => toggleModal(true)} {...extraProps}>
      <span className={classnames(iconClassName, 'mr-1')} />
      {label}
      {showsModal && <FormModal isOpen values={initialValues} onClickClose={_ => toggleModal(false)} onSubmit={onSubmit} {...formProps} />}
    </Button>
  );
};
